"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookEventTypes = void 0;
var WebhookEventTypes;
(function (WebhookEventTypes) {
    WebhookEventTypes["SUBSCRIPTION_VALIDATION"] = "Microsoft.EventGrid.SubscriptionValidationEvent";
    WebhookEventTypes["PLAYER_CHANGE"] = "TPS.Simulator.ChangePlayer";
    WebhookEventTypes["CLUB_CHANGE"] = "TPS.Simulator.ChangeClub";
    WebhookEventTypes["STROKE_COMPLETED"] = "TPS.Live.OnStrokeCompletedEvent";
    WebhookEventTypes["HOLE_COMPLETED"] = "TPS.Simulator.HoleCompleted";
    WebhookEventTypes["SAVE_GAME"] = "TPS.SaveGame";
    WebhookEventTypes["GIVEN_MULLIGAN"] = "TPS.Simulator.GivenMulligan";
    WebhookEventTypes["SHOT_STARTING"] = "TPS.Simulator.ShotStarting";
    WebhookEventTypes["SHOT_FINISH"] = "TPS.Simulator.ShotFinish";
    WebhookEventTypes["START_ACTIVITY"] = "TPS.StartActivity";
    WebhookEventTypes["END_ACTIVITY"] = "TPS.EndActivity";
    WebhookEventTypes["PLAYER_PICKUP"] = "TPS.Simulator.PlayerPickup";
    WebhookEventTypes["SCORECARD"] = "TPS.Simulator.Scorecard";
    WebhookEventTypes["GIVEN_GIMME"] = "TPS.Simulator.GivenGimme";
    WebhookEventTypes["GAME_END"] = "TPS.Simulator.OnGameEndEvent";
    WebhookEventTypes["SESSION_INFO"] = "TPS.SessionInfo";
    WebhookEventTypes["SYSTEM_INFO"] = "TPS.SystemInfo";
})(WebhookEventTypes = exports.WebhookEventTypes || (exports.WebhookEventTypes = {}));
//# sourceMappingURL=TrackmanWebhookEventTypes.js.map